import { useContext, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import {
  getExternalNodesQueryKey,
  listAllNodes,
} from "components/Environment/RegisteredCompute/useNodes";
import { OrgContext } from "contexts/OrgContext";

export const useExternalNodeNames = () => {
  const { activeOrgId } = useContext(OrgContext);
  const { data, isError, isInitialLoading } = useQuery({
    queryKey: getExternalNodesQueryKey(activeOrgId),
    queryFn: () => listAllNodes(activeOrgId!, true),
    enabled: Boolean(activeOrgId),
    staleTime: 30_000,
  });

  const externalNodeNames = useMemo(
    () =>
      new Set(
        (data ?? [])
          .map((node) => node.name.trim().toLowerCase())
          .filter(Boolean),
      ),
    [data],
  );

  return {
    externalNodeNames,
    isError,
    isLoading: isInitialLoading,
  };
};
